module.exports = __webpack_public_path__ + "static/08-773ba0c03c6314f996671354fadfa85e.jpg";